import { MigrationSpec } from "../migration.models"

// Copied literally from CUSTOM_FIELD_LEGACY_DEFAULTS in api-v2's
// CustomFields/core/customFields.constant.ts.
const CUSTOM_FIELD_LEGACY_DEFAULTS: Record<string, unknown> = {
  usage: "CONTACT",
  scope: "PERSON",
  status: "ACTIVE",
  visibleToCustomers: "OPTIONAL",
  visibleToUsers: "OPTIONAL",
  conditions: [],
  isDefault: false,
  multiline: false,
  decimal: false,
  multiSelect: false,
  withTime: false
}

const customFieldDefaults: MigrationSpec = {
  type: "BACKFILL_CUSTOM_FIELD_DEFAULTS",
  collection: "CustomFields",
  risk: "SAFE",
  title: {
    en: "Custom fields: defaults for fields created before 2025-07",
    tr: "Özel alanlar: 2025-07 öncesi açılan alanlara varsayılanlar"
  },
  description: {
    en:
      "Fields created before `usage`, `status` and the visibility settings existed have none of " +
      "those keys, so lists that ask for `usage: CONTACT` or `status: ACTIVE` (settings, contacts, " +
      "conversation detail) never return them while flows still use them. Writes the schema " +
      "default to every missing key (usage CONTACT, scope PERSON, status ACTIVE, both " +
      "visibilities OPTIONAL, empty conditions, the boolean options false). Keys that already " +
      "have a value are not touched.",
    tr:
      "`usage`, `status` ve görünürlük ayarları eklenmeden önce açılmış alanlarda bu anahtarlar " +
      "hiç yok; bu yüzden `usage: CONTACT` ya da `status: ACTIVE` isteyen listeler (ayarlar, " +
      "kişiler, konuşma detayı) onları hiç döndürmüyor, flow'lar ise kullanmaya devam ediyor. " +
      "Eksik her anahtara şemadaki varsayılanı yazar (usage CONTACT, scope PERSON, status ACTIVE, " +
      "iki görünürlük de OPTIONAL, boş conditions, boolean seçenekler false). Değeri olan " +
      "anahtarlara dokunulmaz."
  },
  // Copied literally from backfillLegacyDefaults in api-v2's
  // CustomFields/drivers/customFields.mongo.driver.ts (`field: null` also matches a missing key).
  affectedFilter: {
    $or: Object.keys(CUSTOM_FIELD_LEGACY_DEFAULTS).map((field) => ({
      [field]: null
    }))
  },
  sampleFields: [
    "customer",
    "name",
    "type",
    ...Object.keys(CUSTOM_FIELD_LEGACY_DEFAULTS)
  ],
  preview: (doc) => {
    const after: Record<string, unknown> = { ...doc }
    for (const [field, value] of Object.entries(CUSTOM_FIELD_LEGACY_DEFAULTS)) {
      if (after[field] === undefined || after[field] === null) {
        after[field] = value
      }
    }
    return after
  },
  notes: [
    {
      en:
        "Field ids do not change, so the values stored on persons and the flows that reference " +
        "these fields keep working; the fields simply appear in the lists again.",
      tr:
        "Alan id'leri değişmez; kişilerde saklanan değerler ve bu alanları kullanan flow'lar " +
        "çalışmaya devam eder, alanlar yalnızca listelerde yeniden görünür."
    },
    {
      en: "Every field gets usage CONTACT: before 2025-07 custom fields were contact fields only.",
      tr: "Her alana usage CONTACT yazılır: 2025-07 öncesinde özel alanlar yalnızca kişi alanıydı."
    }
  ]
}

export default customFieldDefaults
